module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-360w.30cc78e6.webp";